// API chatbot lưu một bản ghi theo userId. Luôn kiểm tra cả app và phòng chat
// trước khi dùng bản ghi trong hộp thư của từng nick official.
export const getSupportRoomId = (officialId, userId) =>
    [String(officialId), String(userId)].sort().join('-');

export const matchesSupportConversation = (conversation, account, userId) => !!(
    conversation
    && conversation.userId
    && (!userId || String(conversation.userId) === String(userId))
    && conversation.language === account.language
    && conversation.privateChatId === getSupportRoomId(account.facebookId, conversation.userId)
);

export const toSupportChatUser = (conversation, cachedUser) => ({
    ...cachedUser,
    fromUserId: conversation.userId,
    userName: (cachedUser && cachedUser.userName) || conversation.userName || conversation.userId,
    userProfile: (cachedUser && cachedUser.userProfile) || conversation.avatar,
    // Cùng dữ liệu với Tất cả/Chưa đọc; không thay tin mới nhất bằng tin lúc chuyển ca.
    lastMessage: cachedUser && cachedUser.lastMessage != null
        ? cachedUser.lastMessage : conversation.lastUserMessage || conversation.needAgentMessage || '',
    dateTime: cachedUser && cachedUser.dateTime != null
        ? cachedUser.dateTime : new Date(conversation.lastUserMessageTime || conversation.needAgentTime).getTime() || null,
    isRead: cachedUser ? cachedUser.isRead : false,
    lastUserId: cachedUser ? cachedUser.lastUserId : conversation.userId,
});
